import { Container } from "@mui/material";
import React from "react";
import Navbar, { NAVBAR_SPACE } from "../Navbar/Navbar";
import { navbarBlue } from "../../Classes/theme";
import Ratings from "../Ratings/Ratings";
import PartnersLine from "../PartnersLine/PartnersLine";

export default function Soukromi() {
  return (
    <>
      <Navbar logoWhite defaultColor={navbarBlue} />
      <div style={{ width: "100%", height: "120px" }} />
      <Container
        sx={{ color: "black", textAlign: "left", pb: "30px", px: NAVBAR_SPACE }}
        maxWidth="lg"
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <h1
            style={{
              textAlign: "left",
              marginTop: "0cm",
              fontSize: 28,
              fontWeight: "bold",
              color: "rgb(0, 0, 0)"
            }}
          >
            Zásady ochrany soukromí
          </h1>
          <p style={{ textAlign: "left", color: "rgb(0, 0, 0)" }}>
            <strong>Společnost:</strong> Metastream s.r.o.
          </p>
          <p style={{ textAlign: "left", color: "rgb(0, 0, 0)" }}>
            <strong>IČO:</strong> 08393494
          </p>
          <p style={{ textAlign: "left", color: "rgb(0, 0, 0)" }}>
            <strong>Adresa:</strong> Metastream s.r.o., Brno, Högrova 2862/2
          </p>
          <p style={{ textAlign: "left", color: "rgb(0, 0, 0)" }}>
            Tyto Zásady ochrany soukromí popisují, jak společnost Metastream s.r.o.
            (dále jen „Společnost“) shromažďuje, používá a sdílí vaše osobní údaje. Tyto
            Zásady se vztahují na všechny mobilní aplikace, které Společnost provozuje
            (dále jen „Služba“).
          </p>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)", fontSize: 24 }}>
              <strong>Informace, které shromažďujeme</strong>
            </span>
          </p>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)" }}>
              Aplikace může shromažďovat následující typy osobních údajů:
            </span>
          </p>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Informace, které nám poskytnete:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Jedná se o informace, které nám dobrovolně poskytnete při
                používání Aplikace, jako je vaše jméno, e-mailová adresa, telefonní
                číslo, profilový obrázek a další informace.
              </span>
            </p>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Informace o vašem zařízení:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Aplikace může shromažďovat informace o vašem zařízení, jako je
                jeho typ, operační systém, ID zařízení a IP adresa.
              </span>
            </p>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Informace o používání Aplikace:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Aplikace může shromažďovat informace o tom, jak používáte
                Aplikaci, jako je to, které funkce používáte, jak často Aplikaci
                používáte a s jakými daty v Aplikaci pracujete.
              </span>
            </p>
          </div>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)", fontSize: 24 }}>
              <strong>Jak používáme vaše osobní údaje</strong>
            </span>
          </p>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)" }}>
              Vaše osobní údaje můžeme používat pro následující účely:
            </span>
          </p>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Poskytování služeb Aplikace:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Vaše osobní údaje používáme k tomu, abychom vám mohli poskytovat
                funkce a služby Aplikace.
              </span>
            </p>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Zlepšování Aplikace:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Vaše osobní údaje používáme k tomu, abychom zlepšovali funkce a
                služby Aplikace a abychom vám nabídli relevantnější a personalizovanější
                zážitek.
              </span>
            </p>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Komunikace s vámi:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Vaše osobní údaje používáme k tomu, abychom s vámi komunikovali
                ohledně Aplikace, včetně novinek, aktualizací a zákaznické podpory.
              </span>
            </p>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Pro reklamní účely:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Vaše osobní údaje můžeme používat k zobrazování reklam, které jsou
                pro vás relevantnější.
              </span>
            </p>
          </div>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)", fontSize: 24 }}>
              <strong>Sdílení vašich osobních údajů</strong>
            </span>
          </p>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)" }}>
              Vaše osobní údaje můžeme sdílet s následujícími subjekty:
            </span>
          </p>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Poskytovatelé služeb:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Vaše osobní údaje můžeme sdílet s třetími stranami, které nám
                pomáhají provozovat Aplikaci, jako jsou poskytovatelé cloudových služeb
                a analytické společnosti.
              </span>
            </p>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Orgány dohledu:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Vaše osobní údaje můžeme sdílet s orgány dohledu, pokud je to
                vyžadováno zákonem.
              </span>
            </p>
          </div>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)", fontSize: 24 }}>
              <strong>Vaše práva</strong>
            </span>
          </p>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)" }}>
              Máte následující práva týkající se vašich osobních údajů:
            </span>
          </p>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Přístup k vašim osobním údajům:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Máte právo na přístup k vašim osobním údajům, které o vás
                shromažďujeme.
              </span>
            </p>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Oprava vašich osobních údajů:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Máte právo na opravu vašich osobních údajů, pokud jsou nesprávné
                nebo neúplné.
              </span>
            </p>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Výmaz vašich osobních údajů:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Máte právo požádat o výmaz vašich osobních údajů v určitých
                případech.
              </span>
            </p>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Omezení zpracování vašich osobních údajů:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Máte právo omezit zpracování vašich osobních údajů v určitých
                případech.
              </span>
            </p>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Námitka proti zpracování vašich osobních údajů:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Máte právo vznést námitku proti zpracování vašich osobních údajů v
                určitých případech.
              </span>
            </p>
          </div>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)", fontSize: 24 }}>
              <strong>Odhlášení z marketingových sdělení</strong>
            </span>
          </p>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)" }}>
              Můžete se kdykoli odhlásit z odběru marketingových sdělení od nás. To
              provedete tak, že kliknete na odkaz „Odhlásit se“ v dolní části
              marketingového e-mailu nebo v nastavení Aplikace.
            </span>
          </p>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)", fontSize: 24 }}>
              <strong>Sdílení dat se společnostmi Apple a Google</strong>
            </span>
          </p>
          <p style={{ textAlign: "left", fontSize: 20 }}>
            <span style={{ color: "rgb(0, 0, 0)" }}>
              <strong>Apple:</strong>
            </span>
          </p>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)" }}>
              Aplikace používají některé služby společnosti Apple, které můžou
              shromažďovat a sdílet vaše data. Patří mezi ně:
            </span>
          </p>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Apple App Store:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Společnost Apple shromažďuje informace o vašem zařízení a o tom,
                jak používáte Aplikaci, aby vám mohla poskytovat služby App Store.
              </span>
            </p>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Apple iCloud:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Pokud používáte iCloud k zálohování dat Aplikace, vaše data budou
                sdílena se společností Apple.
              </span>
            </p>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Apple Push Notifications:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Společnost Apple shromažďuje informace o vašem zařízení a o tom,
                jak používáte Aplikaci, aby vám mohla posílat push notifikace.
              </span>
            </p>
          </div>
          <p style={{ textAlign: "left", fontSize: 20 }}>
            <span style={{ color: "rgb(0, 0, 0)" }}>
              <strong>Google:</strong>
            </span>
          </p>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)" }}>
              Aplikace používá některé služby společnosti Google, které můžou
              shromažďovat a sdílet vaše data. Patří mezi ně:
            </span>
          </p>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Google Play Store:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Společnost Google shromažďuje informace o vašem zařízení a o tom,
                jak používáte Aplikaci, aby vám mohla poskytovat služby Google Play.
              </span>
            </p>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Google Firebase:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Společnost Google shromažďuje informace o vašem zařízení a o tom,
                jak používáte Aplikaci, aby vám mohla poskytovat funkce a služby
                Firebase.
              </span>
            </p>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Google Analytics:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Společnost Google shromažďuje informace o vašem zařízení a o tom,
                jak používáte Aplikaci, aby mohla analyzovat používání Aplikace a
                zlepšovat její funkce.
              </span>
            </p>
          </div>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)", fontSize: 24 }}>
              <strong>Další informace:</strong>
            </span>
          </p>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)" }}>
              Další informace o tom, jak Apple a Google shromažďují a používají vaše
              data, naleznete v jejich zásadách ochrany osobních údajů:
            </span>
          </p>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Apple:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>&nbsp;</span>
              <a href="https://www.apple.com/privacy/" target="_blank">
                <span style={{ color: "rgb(0, 0, 255)" }}>
                  <u>https://www.apple.com/privacy/</u>
                </span>
              </a>
            </p>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Google:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>&nbsp;</span>
              <a href="https://policies.google.com/privacy" target="_blank">
                <span style={{ color: "rgb(0, 0, 255)" }}>
                  <u>https://policies.google.com/privacy</u>
                </span>
              </a>
            </p>
          </div>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)", fontSize: 24 }}>
              <strong>Důležité:</strong>
            </span>
          </p>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)" }}>
              Společnost Apple a Google můžou používat vaše data k vlastním účelům,
              které nejsou popsány v těchto Zásadách. Před použitím Aplikace si prosím
              přečtěte zásady ochrany osobních údajů společností Apple a Google.
            </span>
          </p>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)", fontSize: 24 }}>
              <strong>Kontaktní informace:</strong>
            </span>
          </p>
          <p style={{ textAlign: "left" }}>
            <span style={{ color: "rgb(0, 0, 0)" }}>
              Máte-li jakékoli dotazy ohledně těchto Zásad ochrany soukromí, neváhejte
              nás kontaktovat:
            </span>
          </p>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>E-mail:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;info@metastream.cz
              </span>
            </p>
            <p style={{ textAlign: "left" }}>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                <strong>Adresa:</strong>
              </span>
              <span style={{ color: "rgb(0, 0, 0)" }}>
                &nbsp;Metastream s.r.o., Brno, Högrova 2862/2
              </span>
            </p>
          </div>
          <p style={{ textAlign: "left" }}>
            &nbsp;
          </p>
          <p style={{ textAlign: "left" }}>
            <strong>Účinnost:</strong> 2. února 2022
          </p>
          <p style={{ textAlign: "left", marginLeft: "0.64cm" }}>
            <br />
          </p>
        </div>

      </Container>
      <Ratings />
      <PartnersLine bgcolor="transparent" />
    </>
  );
}
